<template>
  <div>
    <vertical>
      <page-header :items="headerItems" title="جزئیات تراکنش" />

      <div v-if="transactionDetail.isIncreaseStatusValue !== 'تراکنش موفق'" class="card p-3">
        <div class="d-flex gap-3 align-items-center">
          <b-button :class="{ disabled: transactionDetail.isIncreaseStatusValue === 'واریز موفق' }" @click="updateManualPaymentStatus('واریز موفق')" variant="outline-primary"
            >واریز موفق</b-button
          >

          <b-button
            :class="{ disabled: transactionDetail.isIncreaseStatusValue === 'در انتظار واریز' }"
            @click="updateManualPaymentStatus('در انتظار واریز')"
            variant="outline-danger"
            >در انتظار واریز</b-button
          >
        </div>
      </div>

      <div class="card p-3 box_detail">
        <div class="parent_box_detail">
          <div class="box">
            <h5 class="m-0">اطلاعات تراکنش</h5>
          </div>

          <section class="d-flex justify-content-between" style="height: 80%">
            <div class="w-50 d-flex flex-column justify-content-between border-right">
              <div class="d-flex gap-2 border-bottom p-3" style="height: 3rem">
                <span>نوع تراکنش</span>
                <span :style="{ color: transactionDetail.isIncreaseColor }">
                  {{ transactionDetail.isIncreaseValue }}
                </span>
              </div>

              <div class="d-flex gap-2 border-bottom p-3" style="height: 3rem">
                <span>مبلغ</span>

                <span>
                  {{ transactionDetail.price || '0' }}
                </span>
              </div>

              <div class="d-flex gap-2 border-bottom p-3" style="height: 3rem">
                <span>دریافت کننده</span>

                <span>
                  {{ transactionDetail.fullName }}
                </span>
              </div>

              <div class="d-flex gap-2 border-bottom p-3" style="height: 3rem">
                <span>شرح تراکنش</span>

                <span>
                  {{ transactionDetail.payDescription }}
                </span>
              </div>
            </div>

            <div class="w-50 d-flex flex-column justify-content-between">
              <div class="d-flex align-items-center gap-2 border-bottom p-3" style="height: 3rem">
                <span>وضعیت</span>

                <span
                  :style="{ color: transactionDetail.isIncreaseStatusColor }"
                  :class="[
                    'py-1 px-2 radius',
                    { isIncreaseStatusBackgroundColorGreen: transactionDetail.isIncreaseStatusValue === 'تراکنش موفق' },
                    { isIncreaseStatusBackgroundColorOrange: transactionDetail.isIncreaseStatusValue === 'در انتظار واریز' },
                    { isIncreaseStatusBackgroundColorPurple: transactionDetail.isIncreaseStatusValue === 'واریز موفق' },
                  ]"
                >
                  {{ transactionDetail.isIncreaseStatusValue }}
                </span>

                <span v-if="transactionDetail.isIncreaseStatusValue !== 'تراکنش موفق'" class="status"> درخواست برداشت از کیف پول </span>
              </div>
              <div class="d-flex gap-2 border-bottom p-3" style="height: 3rem">
                <span>تاریخ و ساعت</span>

                <span>
                  {{ FormatedDate(transactionDetail.date) }}
                </span>
              </div>

              <div class="d-flex gap-2 border-bottom p-3" style="height: 3rem">
                <span>شماره پیگیری</span>

                <span>
                  {{ transactionDetail.referenceNumber }}
                </span>
              </div>

              <div class="d-flex gap-2 border-bottom p-3" style="height: 3rem">
                <div v-if="walletType === 'TOMAN'">
                  <span>شماره شبا</span>

                  <span>
                    {{ transactionDetail.SHABANumber }}
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div v-if="transactionDetail.isIncreaseStatusValue !== 'تراکنش موفق'" class="card">
        <div class="order-header">
          <h5 class="header">اطلاعات تراکنش</h5>
        </div>

        <div>
          <div class="my-3">
            <UploadBox
              :cloud="true"
              accept="image/*,.xlsx,.pdf,.docx,.pptx"
              @fileBoxData="uploadedFile($event)"
              :imageHeight="220"
              :imageFile="transactionDetail.manualPaymentUrl"
              :fileType="transactionDetail.manualPaymentUrlType"
              :fileTitle="transactionDetail.manualPaymentUrlName"
              :filesLength="1"
              placeholder="عکس یا فایل واریز مبلغ برداشت برای کاربر  را بارگزاری نمایید  "
            />
          </div>

          <div class="textArea">
            <text-area-input v-model="transactionDetail.manualPaymentDescription" title="توضیحات ادمین" />
          </div>
        </div>

        <div class="p-3 py-2 d-flex gap-3 justify-content-end">
          <b-button @click="$router.push(`/list/allbalancewithuserinfo/detail/${transactionDetail.transactionId}`)">انصراف</b-button>

          <b-button
            :disabled="(!transactionDetail.manualPaymentDescription && !transactionDetail.manualPaymentUrl && !secondUrl) || loading"
            @click="onSubmit"
            variant="primary"
            style="width: 120px"
          >
            <div>
              <span>ثبت </span>

              <i v-if="loading" class="fas fa-spinner fa-spin"></i>
            </div>
          </b-button>
        </div>
      </div>
    </vertical>
    <toast :showToast="showToast" :error="error" :title="toastMessage" />
  </div>
</template>

<script>
import skillUpWallet from '../../../services/skillUp/wallet'
import vertical from '../../../layouts/vertical.vue'
import pageHeader from '../../layoutComponents/page-header.vue'
import UploadBox from '../../common/form/formModules/UploadBox.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Toast from '../../common/Toast.vue'
export default {
  components: { vertical, pageHeader, UploadBox, TextAreaInput, Toast },
  data() {
    return {
      showToast: false,
      error: false,
      loading: false,
      toastMessage: '',
      transactionDetail: {},
      secondUrl: '',
      secondUrlName: '',
      secondUrlType: '',
      headerItems: [
        {
          text: 'موجودی کیف پول کاربر',
          href: `/list/allbalancewithuserinfo/detail/${this.transactionDetail ? this.transactionDetail.transactionId : undefined}`,
        },
        {
          text: 'جزئیات تراکنش',
          active: true,
        },
      ],
      detail: {},
      walletType: '',
    }
  },

  created() {
    this.transactionDetail = JSON.parse(window.localStorage.getItem('transactionDetail'))
    this.walletType = JSON.parse(window.localStorage.getItem('walletUserInformation')).walletType
  },

  methods: {
    async onSubmit() {
      const file = {
        manualPaymentDescription: this.description || this.transactionDetail.manualPaymentDescription,
        manualPaymentUrl: this.secondUrl || this.transactionDetail.manualPaymentUrl,
        manualPaymentUrlName: this.secondUrlName || this.transactionDetail.manualPaymentUrlName,
        manualPaymentUrlType: this.secondUrlType || this.transactionDetail.manualPaymentUrlType,
      }
      const payload = {
        ...this.transactionDetail,
        manualPaymentUrl: file.manualPaymentUrl,
        manualPaymentDescription: file.manualPaymentDescription,
        manualPaymentUrlName: file.manualPaymentUrlName,
        manualPaymentUrlType: file.manualPaymentUrlType,
      }
      try {
        this.loading = true
        await skillUpWallet.updateManualPayment({
          id: this.transactionDetail.id,
          manualPaymentUrl: file.manualPaymentUrl,
          manualPaymentDescription: file.manualPaymentDescription,
          manualPaymentUrlName: file.manualPaymentUrlName,
          manualPaymentUrlType: file.manualPaymentUrlType,
        })
        window.localStorage.setItem('transactionDetail', JSON.stringify(payload))
        this.transactionDetail = JSON.parse(window.localStorage.getItem('transactionDetail'))

        this.loading = true
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = false
          this.toastMessage = 'تغییرات با موفقیت ذخیره شد.'
        })
      } catch (error) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.toastMessage = 'مشکلی پیش آمده است لطفا دوباره تلاش کنید.'
        })
      } finally {
        this.loading = false
      }
    },
    async updateManualPaymentStatus(type) {
      const payload = {
        ...this.transactionDetail,
        isIncreaseStatusValue: type,
        isIncreaseStatusColor: type === 'واریز موفق' ? 'rgb(153,153,255)' : 'rgb(248, 119, 0, 1)',
        manualPaymentStatus: type === 'واریز موفق' ? true : false,
      }
      window.localStorage.setItem('transactionDetail', JSON.stringify(payload))
      this.transactionDetail = JSON.parse(window.localStorage.getItem('transactionDetail'))

      try {
        await skillUpWallet.updateManualPaymentStatus({
          id: this.transactionDetail.id,
          manualPayment: type === 'واریز موفق' ? true : false,
        })

        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = false
          this.toastMessage = 'تغییرات با موفقیت ذخیره شد.'
        })
      } catch (error) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.toastMessage = 'مشکلی پیش آمده است لطفا دوباره تلاش کنید.'
        })
      } finally {
        window.localStorage.setItem('transactionDetail', JSON.stringify(payload))
        this.transactionDetail = JSON.parse(window.localStorage.getItem('transactionDetail'))

        // window.location.reload()
      }
    },
    uploadedFile($event) {
      if (Array.isArray($event) && !$event.length) {
        this.secondUrl = ''
        this.secondUrlName = ''
        this.secondUrlType = ''
        this.transactionDetail.manualPaymentUrl = ''
        this.transactionDetail.manualPaymentUrlName = ''
        this.transactionDetail.manualPaymentUrlType = ''
        return
      }
      if (Array.isArray($event) && $event.length) {
        this.secondUrl = $event[0]?.url
        this.secondUrlName = $event[0]?.name
        this.secondUrlType = $event[0]?.name.split('.')[$event[0].name.split('.').length - 1]
        return
      }
    },
  },
}
</script>

<style scoped>
::v-deep .btn-outline-primary:hover {
  color: #556ee6 !important;
  border-color: #556ee6 !important;
  background-color: white !important;
}

::v-deep .btn-outline-danger:hover {
  color: #f46a6a !important;
  border-color: #f46a6a !important;
  background-color: white !important;
}
.box {
  background-color: rgba(248, 249, 250, 1);
  box-shadow: 2px -3px 3px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  border-radius: 7px 8px 4px 0px;
}

.parent_box_detail {
  height: 17rem;
  border: 1px solid rgba(240, 241, 241, 1);
  border-bottom: none;
  border-radius: 8px;
}

.box_detail {
  height: 20rem;
}

.order-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 8px;
  position: relative;
  background: #f8f9fa;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
}

.header {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #444444;
}

.textArea {
  margin: 22px 13px;
}

::v-deep .mainCloud {
  margin-right: 0;
}

.isIncreaseStatusBackgroundColorOrange {
  background: rgba(255, 203, 166, 1) !important;
}

.isIncreaseStatusBackgroundColorPurple {
  background: rgba(24, 59, 167, 0.15) !important;
}

.isIncreaseStatusBackgroundColorGreen {
  background: rgba(218, 244, 235, 1) !important;
}

.radius {
  border-radius: 16px;
}

.status {
  background-color: rgba(244, 234, 218, 1);
  color: rgba(239, 150, 100, 1);
  padding: 4px 8px;
  border-radius: 16px;
}

.disabled {
  opacity: 0.2;
  pointer-events: none;
}
</style>
